<template>
  <div class="pageFooter">
    <div class="footerBanner HomeContainer">
      <div class="bannerItem" style="justify-content: flex-start">
        <el-image
          :src="GetResourceUrl('footer/icon-star.svg')"
        ></el-image>
        <div class="font">
          <div class="title">{{l("降本增效")}}</div>
          <div class="desc">{{l("海量商机，智能优推，快人一步")}}</div>
        </div>
      </div>
      <div class="bannerItem" style="justify-content: center">
        <el-image
          :src="GetResourceUrl('footer/icon-buyer.svg')"
        ></el-image>
        <div class="font">
          <div class="title">{{l("买卖无忧")}}</div>
          <div class="desc">{{l("会员认证、评信、监督，三大体系保驾护航")}}</div>
        </div>
      </div>
      <div class="bannerItem" style="justify-content: flex-end">
        <el-image
          :src="GetResourceUrl('footer/icon-service.svg')"
        ></el-image>
        <div class="font">
          <div class="title">{{l("优质服务")}}</div>
          <div class="desc">{{l("专业人员7×24小时，一对一服务")}}</div>
        </div>
      </div>
    </div>
    <div class="footerContainer">
      <div
        class="HomeContainer"
        style="display: flex; justify-content: space-between"
      >
        <div class="entryList">
          <div class="entryColumn">
            <div class="title">{{l("操作指南")}}</div>
            <router-link class="content" to="/home/help?key=新手指南"
              >{{l("新手指南")}}</router-link
            >
            <router-link class="content" to="/home/help?key=参与拼单"
              >{{l("如何参与拼单")}}</router-link
            >
            <router-link class="content" to="/home/help?key=管理发布内容"
              >{{l("管理发布内容")}}</router-link
            >
            <router-link class="content" to="/home/help?key=查看询/报价"
              >{{l("查看询/报价")}}</router-link
            >
          </div>
          <div class="entryColumn">
            <div class="title">{{l("常见问题")}}</div>

            <router-link class="content" to="/home/help?key=如何联系客户"
              >{{l("如何联系客户")}}</router-link
            >
            <router-link class="content" to="/home/help?key=如何邀请子账号"
              >{{l("如何邀请子账号")}}</router-link
            >
            <router-link class="content" to="/home/help?key=发布内容待审核"
              >{{l("发布的内容待审核")}}</router-link
            >
            <router-link class="content" to="/home/help?key=批量发布商品"
              >{{l("批量发布商品")}}</router-link
            >
          </div>
          <div class="entryColumn">
            <div class="title">{{l("关于我们")}}</div>
            <router-link class="content" to="/home/help?key=平台介绍"
              >{{l("平台介绍")}}</router-link
            >
            <router-link class="content" to="/home/help?key=用户协议"
              >{{l("用户协议")}}</router-link
            >
            <router-link class="content" to="/home/help?key=隐私政策"
              >{{l("隐私政策")}}</router-link
            >
            <router-link class="content" to="/home/site_map">{{l("网站地图")}}</router-link>
          </div>
        </div>

        <div class="contact">
          <div>
            <div class="title">
              <i class="el-icon-phone-outline"></i>
              {{l("客服电话")}}
            </div>
            <div class="phone">400-617-3617</div>
            <div>[{{l("周一至周日")}} 00:00~24:00]</div>
          </div>
          <div style="margin-top: 30px">
            <div class="title">
              <i class="el-icon-message"></i>
              {{l("客服邮箱")}}
            </div>
            <div style="margin: 12px 0 0; letter-spacing: 1px">
              chinaduancai@163.com
            </div>
          </div>
        </div>
        <div class="qrcodes">
          <div class="qrcodeContainer">
            <el-image
              alt="中锻材 中国锻材网 公众号"
              src="https://oss.chinaduancai.com/public_account.jpg"
            ></el-image>
            <div style="margin-top: 8px">微信扫码使用手机版</div>
            <div style="margin-top: 6px; color: #eee">
              手机询报价，沟通更便捷
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer HomeContainer">
      <div class="copyright">
        Copyright ©
        {{ new Date().getFullYear() }} 中锻材（无锡）信息服务有限公司 All Rights
        Reserved

        <a
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            color: #939393;
            margin-left: 10px;
          "
          target="_blank"
          href="/icp"
        >
          经营许可证苏B2-20211307
        </a>

        <a
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            color: #939393;
            margin-left: 10px;
          "
          target="_blank"
          href="https://beian.miit.gov.cn/"
        >
          苏ICP备2021002344号-2
        </a>

        <br />

        <span>江苏省无锡市滨湖区太湖明珠发展大厦1705室</span>

        <a
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            color: #939393;
            margin-left: 10px;
          "
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102001182"
        >
          <img alt="中锻材ICP" :src="GetResourceUrl('ICP.png')" />
          苏公网安备 32021102001182号
        </a>
      </div>
      <div class="certs">
        <a target="_blank" href="http://www.wxfia.com/">
          <img
            alt="无锡锻压协会"
            :src="GetResourceUrl('cert/wxfia.png')"
          />
          <span> 无锡锻压协会 </span>
        </a>
        <a target="_blank" href="https://www.cmes.org/">
          <img
            alt="中国机械工程学会"
            :src="GetResourceUrl('cert/chinaforge.jpg')"
          />
          <span> 中国机械工程学会 </span>
        </a>

        <a target="_blank" href="https://www.12377.cn/">
          <img
            alt="互联网举报中心"
            :src="GetResourceUrl('cert/12377.png')"
          />
          <span> 互联网举报中心 </span>
        </a>

        <a target="_blank" href="http://www.cyberpolice.cn/wfjb/">
          <img
            alt="网络警察提醒您"
            :src="GetResourceUrl('cert/police.png')"
          />
          <span> 网络警察提醒您 </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pageFooter",
  data() {
    return {
      isDemo: false,
    };
  },
  created() {
    if (
      window.location.href.indexOf("local") != -1 ||
      window.location.href.indexOf("demo") != -1
    ) {
      this.isDemo = true;
    }
  },
  methods: {},
};
</script>
<style scoped lang="scss">

.pageFooter {
  border-top: 1px solid $borderPlainColor;
  background: #fff;
  // margin-top: 30px;
  .footerBanner {
    display: flex;
    justify-content: space-between;
    color: #666;
    padding: 20px 10px;
    .bannerItem {
      display: flex;
      align-items: center;
      width: 33.3%;
      .el-image {
        width: 40px;
        height: 40px;
      }
      .font {
        margin-left: 10px;
        .title {
          font-size: 18px;
          color: #333;
        }
        .desc {
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }
  .footerContainer {
    background: $oldThemeColor;
    color: #fff;
    padding: 30px 0;
    .entryList {
      margin-left: 20px;
      margin-right: 50px;
      width: 40%;
      display: flex;
      justify-content: space-between;
      text-align: center;

      .entryColumn {
        position: relative;
        .title {
          font-weight: bold;
          margin-bottom: 1vw;
          font-size: 14px;
        }

        .content {
          color: #fff;
          margin-bottom: 10px;
          // cursor: pointer;
          font-size: 12px;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }

    .contact {
      // margin-right: 5%;
      // display: flex;
      // justify-content: space-around;
      // flex-direction: column;
      // text-align: center;
      font-size: 12px;
      .title {
        font-size: 14px;
        position: relative;
        line-height: 18px;
        i {
          position: absolute;
          color: $warningColor;
          left: -30px;
          font-size: 18px;
        }
      }
      .phone {
        color: $warningColor;
        font-size: 28px;
        margin: 5px 0;
      }
    }
    .qrcodes {
      display: flex;
      font-size: 14px;
      text-align: center;
      .qrcodeContainer {
        .el-image {
          width: 100px;
          height: 100px;
          outline: 1px solid #ccc;
          // margin-bottom: 12px;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 15px;
    .copyright {
      font-size: 12px;
      line-height: 20px;
      color: #939393;
    }
    .certs {
      display: flex;
      a {
        display: flex;
        align-items: center;
        font-size: 12px;
        & + a {
          margin-left: 10px;
        }
        img {
          height: 30px;
        }
        span {
          margin-left: 4px;
          color: #555;
          max-width: 48px;
        }
      }
    }
  }
}
</style>